import { createSelectItem } from 'bones/utils/select/createSelectItem';
import { SelectItem } from 'bones/utils/select/types';

export const SELECT_ITEM_DIVIDER_VALUE = '__divider__';

export const createSelectItemDivider = <T extends SelectItem | null = null>(
  text: string
) => createSelectItem<T>(text, SELECT_ITEM_DIVIDER_VALUE);
